<template>
  <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }">
    
    <div class="container-fluid py-4">
      <div class="row">
        <div class="col-12">
          <h1 class="mb-3">Distribuição de Processos em Lote</h1>
          
          <div class="alert alert-info border-0 shadow-sm mb-4">
            <div class="d-flex align-items-center">
              <i class="fas fa-layer-group fa-2x me-3 text-primary"></i>
              <div>
                <h5 class="alert-heading fw-bold mb-1">Configuração do Processo Modelo</h5>
                <p class="mb-0 text-justify">
                    Preencha as informações abaixo para criar o <strong>processo base</strong>. Após salvar as informações iniciais, os demais passos serão liberados para que você defina os detalhes do processo que será replicado para os alunos. Ao final, será possível definir as preferencias da distribuição.
                </p>
              </div>
            </div>
          </div>

        <div class="d-flex justify-content-start mb-2" v-if="!processo.id">
            <button type="button" class="btn btn-sm btn-outline-info" @click="GerarAleatorioPasso1">
                <i class="fas fa-magic me-1"></i> Preencher Passo 1 Aleatoriamente
            </button>
        </div>

          <div class="form-container mb-3 shadow-sm">
            <div class="form-title text-primary">1. Informações Preliminares do Modelo</div>
            <div class="row p-2">
              <div class="col-md-4">
                <label class="fw-bold mt-1 small">Cidade:</label>
                <select class="form-control form-control-sm mb-2" v-model="cidade_selecionada" :disabled="processo.id">
                  <option v-for="cidade in cidades" :key="cidade.id" :value="cidade.id">{{ cidade.descricao }}</option>
                </select>

                <label class="fw-bold mt-1 small">Rito:</label>
                <select class="form-control form-control-sm mb-2" v-model="rito_selecionado" :disabled="processo.id">
                  <option v-for="rito in ritos" :key="rito.id" :value="rito.id">{{ rito.descricao }}</option>
                </select>

                <label class="fw-bold mt-1 small">Área:</label>
                <select class="form-control form-control-sm mb-2" v-model="area_selecionada" :disabled="processo.id">
                  <option v-for="area in areas" :key="area.id" :value="area.id">{{ area.descricao }}</option>
                </select>
              </div>

                <div class="col-md-4">
                    <label class="fw-bold mt-1 small">Classe Processual:</label>
                    <select class="form-control form-control-sm mb-2" v-model="classe_processual_selecionada" :disabled="processo.id">
                        <option v-for="classe in classes_processuais" :key="classe.id" :value="classe">{{ classe.descricao }}</option>
                    </select>

                    <label class="fw-bold mt-1 small">Valor da Causa (R$):</label>
                    <input type="text" class="form-control form-control-sm" 
                        :class="{'mb-2': valor_causa == 0}" 
                        v-model="valor_causa" 
                        @input="formatarValorMonetario" 
                        :disabled="processo.id">
                    
                    <div v-if="valor_causa != 0" class="d-flex align-items-center mt-1 mb-2 p-1 bg-light border rounded">
                        <i class="fas fa-calculator text-muted me-2 small"></i>
                        <small class="text-muted fw-bold me-1">Previsão Custas:</small>
                        <small class="text-primary fw-bold">{{ previsao_custas }}</small>
                    </div>

                    <label class="fw-bold mt-1 small">Sigilo:</label>
                    <select class="form-control form-control-sm" v-model="nivel_sigilo_selecionado" :disabled="processo.id">
                        <option :value="0">Sem Sigilo (Nível 0)</option>
                        <option :value="1">Com Sigilo (Nível 1)</option>
                    </select>
                </div>

              <div class="col-md-4 d-flex align-items-end">
                <div class="w-100 pb-2">
                    <button v-if="!processo.id" @click="GravarProcessoInicial" class="btn btn-primary w-100 shadow-sm" :disabled="carregando">
                        <i class="fas fa-save me-2"></i> {{ carregando ? 'Gravando...' : 'Iniciar Configuração do Modelo' }}
                    </button>
                    <div v-else class="alert alert-success py-2 mb-0 text-center">
                        <i class="fas fa-check-circle"></i> Modelo Inicializado (ID: {{ processo.id }})
                        <br />{{ processo.codigo_processo }}
                    </div>
                </div>
              </div>
            </div>
          </div>


          <div v-if="processo.id">
            
            <hr class="my-5 border-2 border-primary opacity-25">

            <div class="alert alert-secondary d-flex justify-content-between align-items-center">
                <div>
                    <i class="fas fa-robot me-2"></i>
                    <strong>Acelerar Configuração:</strong> Deseja que o sistema sorteie Assuntos e Partes automaticamente?
                </div>
                <button class="btn btn-primary btn-sm" @click="GerarDetalhesAleatoriosBackend" :disabled="gerando_aleatorios">
                    <i class="fas fa-magic me-1" :class="{'fa-spin': gerando_aleatorios}"></i> 
                    {{ gerando_aleatorios ? 'Gerando...' : 'Gerar Assuntos e Partes Aleatórios' }}
                </button>
            </div>





            <div class="mb-5">
              <h4 class="text-secondary mb-3"><i class="fas fa-list-ul me-2"></i> 2. Assuntos do Processo</h4>
              <processo-assunto-component :key="'assunto-' + componentKey"></processo-assunto-component>
            </div>

            <hr class="my-5">

            <div class="mb-5">
              <h4 class="text-secondary mb-3"><i class="fas fa-users me-2"></i> 3. Definição das Partes (Modelo)</h4>
              <div class="alert alert-warning small">
                <i class="fas fa-exclamation-triangle me-1"></i>
                <strong>Atenção:</strong> Configure aqui os Autores e Réus do caso. 
                Os alunos (advogados) serão inseridos na etapa 5.
              </div>
              <div class="row">
                <div class="col-12 mb-4">
                   <div class="p-2 bg-light border-start border-4 border-info mb-2 small fw-bold">POLO ATIVO</div>
                   <processo-partes-component :polo="1" :key="'autor-' + componentKey"></processo-partes-component>
                </div>
                <div class="col-12">
                   <div class="p-2 bg-light border-start border-4 border-danger mb-2 small fw-bold">POLO PASSIVO</div>
                   <processo-partes-component :polo="2" :key="'reu-' + componentKey"></processo-partes-component>
                </div>
              </div>
            </div>

            <hr class="my-5">

            <div class="mb-5">
              <h4 class="text-secondary mb-3"><i class="fas fa-file-pdf me-2"></i> 4. Documentos da Petição</h4>
              <processo-documentos-component></processo-documentos-component>
            </div>

            <hr class="my-5">

            <div class="p-4 border rounded bg-white shadow-sm mb-5 border-top border-4 border-success">
              <h4 class="text-success mb-4"><i class="fas fa-share-nodes me-2"></i> 5. Distribuição para Alunos</h4>
              
              <div class="row mb-4">
                <div class="col-12">
                    <label class="fw-bold mb-2">Selecione o Modo de Distribuição:</label>
                    <div class="d-flex gap-3">
                        <div class="card-option w-50 p-3 border rounded cursor-pointer" 
                             :class="{'selected-mode': modo_distribuicao === 'compartilhado'}"
                             @click="AlteradoModoDistribuicao('compartilhado')">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="compartilhado" 
                                    :checked="modo_distribuicao === 'compartilhado'" readonly style="pointer-events: none;">
                                <label class="form-check-label fw-bold">Processo Único (Colaborativo)</label>
                            </div>
                            <p class="small text-muted mt-2 mb-0 ms-4 text-justify">
                                Todos os alunos selecionados atuarão <strong>no mesmo processo</strong>. 
                                Você definirá quem será advogado do Autor e quem será do Réu.
                            </p>
                        </div>

                        <div class="card-option w-50 p-3 border rounded cursor-pointer"
                             :class="{'selected-mode': modo_distribuicao === 'individual'}"
                             @click="AlteradoModoDistribuicao('individual')">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" value="individual" 
                                    :checked="modo_distribuicao === 'individual'" readonly style="pointer-events: none;">
                                <label class="form-check-label fw-bold">Cópia Individual (Avaliação)</label>
                            </div>
                            <p class="small text-muted mt-2 mb-0 ms-4 text-justify">
                                O sistema criará uma <strong>CÓPIA NOVA</strong> deste processo para CADA aluno.
                                O aluno será o autor/dono da sua própria cópia.
                            </p>
                        </div>
                    </div>
                </div>
              </div>






                <div class="form-container mb-3 bg-light" v-if="modo_distribuicao === 'compartilhado' || modo_distribuicao === 'individual'">
                    <div class="form-title text-success">Selecionar Alunos / Turmas</div>
                    
                    <div v-if="modo_distribuicao === 'compartilhado' || modo_distribuicao === 'individual'" class="row mb-3 justify-content-center">
                        <div class="col-md-8 text-center bg-white p-2 border rounded">
                            <label class="fw-bold me-3">Adicionar selecionados em:</label>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="destinoAtivo" value="ativo" v-model="destino_colaborativo_selecionado">
                                <label class="form-check-label text-info fw-bold" for="destinoAtivo">Polo Ativo (Autores)</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="destinoPassivo" value="passivo" v-model="destino_colaborativo_selecionado">
                                <label class="form-check-label text-danger fw-bold" for="destinoPassivo">Polo Passivo (Réus)</label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        
                        <div class="col-md-6 border-end">
                            <label class="small fw-bold"><i class="fas fa-user me-1"></i> Buscar Aluno (Individual):</label>
                            <div class="position-relative">
                                <input type="text" v-model="termo_busca_aluno" @input="buscaAlunos" 
                                    placeholder="Digite nome ou CPF..." class="form-control form-control-sm" />
                                
                                <ul v-if="alunos_encontrados.length" class="list-group list-group-flush position-absolute w-100 shadow-sm" style="z-index: 2000; max-height: 200px; overflow-y: auto;">
                                    <li v-for="aluno in alunos_encontrados" :key="aluno.id" 
                                        class="list-group-item list-group-item-action cursor-pointer d-flex justify-content-between align-items-center" 
                                        @click="adicionarItem(aluno, 'aluno')">
                                        <span>{{ aluno.name }}</span>
                                        <i class="fas fa-plus-circle text-success"></i>
                                    </li>
                                </ul>
                            </div>
                            <small class="text-muted" style="font-size: 10px;">Digite pelo menos 3 caracteres.</small>
                        </div>

                        <div class="col-md-6">
                            <label class="small fw-bold"><i class="fas fa-users me-1"></i> Buscar Turma / Grupo:</label>
                            <div class="position-relative">
                                <input type="text" v-model="termo_busca_grupo" @input="buscaGrupos" 
                                    placeholder="Digite o nome da turma..." class="form-control form-control-sm" />
                                
                                <ul v-if="grupos_encontrados.length" class="list-group list-group-flush position-absolute w-100 shadow-sm" style="z-index: 2000; max-height: 200px; overflow-y: auto;">
                                    <li v-for="grupo in grupos_encontrados" :key="grupo.id" 
                                        class="list-group-item list-group-item-action cursor-pointer" 
                                        @click="adicionarItem(grupo, 'grupo')">
                                        <div>
                                            <strong>{{ grupo.descricao }}</strong><br />
                                            <small class="text-muted" style="font-size: 10px;">
                                                <small>Membros: {{ grupo.users.map(member => member.name).join(', ') }}</small>
                                            </small>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <small class="text-muted" style="font-size: 10px;">Todos os membros do grupo serão adicionados.</small>
                        </div>

                    </div>






                <div class="row mt-2">
                    
                    <div v-if="modo_distribuicao === 'individual_este_modo_foi_desativado'" class="col-12">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                             <label class="small fw-bold">Alunos Selecionados ({{ alunos_selecionados_individual.length }}):</label>
                             <!-- <button class="btn btn-xs btn-link text-muted" @click="gerarAlunosTeste">Carregar Fictícios</button> -->
                        </div>
                        <div class="border rounded bg-white p-0" style="height: 200px; overflow-y: auto;">
                            <table class="table table-sm table-striped table-hover mb-0">
                                <thead class="table-light sticky-top">
                                    <tr>
                                        <th>Aluno</th>
                                        <th style="width: 50px;" class="text-center">Remover</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(aluno, index) in alunos_selecionados_individual" :key="aluno.id">
                                        <td class="small align-middle">{{ aluno.name }}</td>
                                        <td class="text-center">
                                            <button class="btn btn-link text-danger p-0" @click="removerAluno(index, 'individual')"><i class="fas fa-times"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="modo_distribuicao === 'compartilhado' || modo_distribuicao === 'individual'" class="col-12">
                        <div class="d-flex justify-content-end mb-2">
                            <!-- <button class="btn btn-xs btn-link text-muted" @click="gerarAlunosTeste">Carregar Fictícios (Ambos)</button> -->
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="card border-info mb-3">
                                    <div class="card-header bg-info text-white py-1 small fw-bold">
                                        <i class="fas fa-user-tie me-1"></i> Advogados (Polo Ativo/Autores)
                                        <span class="badge bg-white text-info float-end">{{ alunos_polo_ativo.length }}</span>
                                    </div>
                                    <div class="card-body p-0" style="height: 200px; overflow-y: auto;">
                                        <table class="table table-sm table-hover mb-0">
                                            <tbody>
                                                <tr v-for="(aluno, index) in alunos_polo_ativo" :key="aluno.id">
                                                    <td class="small">{{ aluno.name }}</td>
                                                    <td class="text-center" style="width: 30px;">
                                                        <button class="btn btn-link text-danger p-0" @click="removerAluno(index, 'ativo')"><i class="fas fa-times"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="card border-danger mb-3">
                                    <div class="card-header bg-danger text-white py-1 small fw-bold">
                                        <i class="fas fa-gavel me-1"></i> Advogados (Polo Passivo/Réus)
                                        <span class="badge bg-white text-danger float-end">{{ alunos_polo_passivo.length }}</span>
                                    </div>
                                    <div class="card-body p-0" style="height: 200px; overflow-y: auto;">
                                        <table class="table table-sm table-hover mb-0">
                                            <tbody>
                                                <tr v-for="(aluno, index) in alunos_polo_passivo" :key="aluno.id">
                                                    <td class="small">{{ aluno.name }}</td>
                                                    <td class="text-center" style="width: 30px;">
                                                        <button class="btn btn-link text-danger p-0" @click="removerAluno(index, 'passivo')"><i class="fas fa-times"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
              </div>

              <div class="row mt-4" v-if="modo_distribuicao != ''">
                <div class="col-12">
                    <div class="alert" :class="modo_distribuicao === 'individual' ? 'alert-warning' : 'alert-info'">
                        <i class="fas fa-info-circle me-2"></i>
                        <span v-if="modo_distribuicao === 'individual'">
                            Serão gerados <strong>{{ (alunos_polo_ativo.length + alunos_polo_passivo.length) }} novos processos</strong> (cópias). Cada aluno administrará o seu conforme o Polo indicado.
                        </span>
                        <span v-else>
                            Este processo único terá <strong>{{ alunos_polo_ativo.length }} advogados no Polo Ativo</strong> e 
                            <strong>{{ alunos_polo_passivo.length }} advogados no Polo Passivo</strong>.
                        </span>
                    </div>

                    <button class="btn btn-lg w-100 fw-bold shadow"
                            :class="modo_distribuicao === 'individual' ? 'btn-success' : 'btn-primary'"
                            :disabled="verificarBloqueioBotao"
                            @click="ExecutarDistribuicao">
                        <span v-if="processando_distribuicao">
                            <i class="fas fa-spinner fa-spin me-2"></i> Processando...
                        </span>
                        <span v-else>
                            <i class="fas fa-paper-plane me-2"></i> 
                            {{ modo_distribuicao === 'individual' ? 'GERAR DISTRIBUIÇÃO EM MASSA' : 'SALVAR VÍNCULOS COLABORATIVOS' }}
                        </span>
                    </button>
                </div>
              </div>

            </div>

          </div> </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProcessoAssuntoComponent from './ProcessoAssuntoComponent.vue';
import ProcessoPartesComponent from './ProcessoPartesComponent.vue';
import ProcessoDocumentosComponent from './ProcessoDocumentosComponent.vue';

export default {
    components: {
        ProcessoAssuntoComponent,
        ProcessoPartesComponent,
        ProcessoDocumentosComponent
    },
    props: {
        user: { type: Object, required: true },
    },
    computed: {
        verificarBloqueioBotao() {
            if (this.processando_distribuicao) return true;
            
            if (this.modo_distribuicao === 'individual_este_modo_foi_desativado') {
                return this.alunos_selecionados_individual.length === 0;
            } else {
                // No modo colaborativo, precisa ter pelo menos 1 aluno em algum dos polos? 
                // Ou obrigatoriamente nos dois? Deixei flexível (pelo menos 1 no total)
                return (this.alunos_polo_ativo.length + this.alunos_polo_passivo.length) === 0;
            }
        }
    },
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            carregando: false,
            processando_distribuicao: false,
            
            processo: {}, 

            // Dados passo 1
            cidade_selecionada: '',
            cidades: [],
            rito_selecionado: '',
            ritos: [],
            area_selecionada: '',
            areas: [],
            classe_processual_selecionada: '',
            classes_processuais: [],
            nivel_sigilo_selecionado: 0,
            valor_causa: '',
            
            // Dados API extras
            processo_originario: '',
            juizo: '',
            previsao_custas: 0,
            valor_causa_nao_se_aplica: false,
            valor_alcada: false,
            login_outros_usuarios: [],

            // --- CONFIGURAÇÃO DE LOTE ---
            modo_distribuicao: '', //'individual', 
            termo_busca_aluno: '',
            alunos_encontrados: [],
            
            // Listas separadas para organizar a lógica
            alunos_selecionados_individual: [],
            alunos_polo_ativo: [],
            alunos_polo_passivo: [],

            termo_busca_aluno: '',
            alunos_encontrados: [],
            
            termo_busca_grupo: '',
            grupos_encontrados: [],

            // Novo: Controle de destino para o modo colaborativo
            destino_colaborativo_selecionado: 'ativo', // Padrão inicial

            componentKey: 0, // Variável para forçar re-renderização
            gerando_aleatorios: false,
        };
    },
    methods: {


        GerarAleatorioPasso1() {
            // Função auxiliar para pegar item aleatório de array
            const random = (arr) => arr[Math.floor(Math.random() * arr.length)];

            if (this.cidades.length) this.cidade_selecionada = random(this.cidades).id;
            if (this.ritos.length) this.rito_selecionado = random(this.ritos).id;
            if (this.areas.length) this.area_selecionada = random(this.areas).id;
            if (this.classes_processuais.length) {
                // O v-model da classe espera o objeto inteiro, não só o ID
                this.classe_processual_selecionada = random(this.classes_processuais);
            }

            // Gera valor entre 1.000 e 50.000
            const valorAleatorio = (Math.random() * (50000 - 1000) + 1000).toFixed(2);
            // Formata para o padrão brasileiro que sua função formatarValorMonetario espera (sem R$)
            this.valor_causa = valorAleatorio.replace('.', ',');
            this.formatarValorMonetario(); // Chama sua função para aplicar a máscara correta

            this.nivel_sigilo_selecionado = Math.random() > 0.5 ? 0 : 1;
        },

        // --- LÓGICA PASSO 2 E 3 (BACKEND) ---
        GerarDetalhesAleatoriosBackend() {
            //if(!confirm("Isso irá substituir os Assuntos e Partes atuais por novos aleatórios. Deseja continuar?")) return;

            this.gerando_aleatorios = true;

            axios.post(this.BASE_URL + `processos/${this.processo.id}/gerar_detalhes_aleatorios`)
                .then(response => {
                    // 1. Atualiza os dados no Store e na variável local
                    this.processo = response.data;
                    this.$store.commit('setProcesso', this.processo);
                    
                    // 2. MÁGICA VISUAL: Incrementa a chave para forçar os componentes a recarregarem
                    this.componentKey += 1; 

                    console.log(this.processo);
                    // Feedback visual suave (opcional: toastr é melhor que alert)
                    // alert("Dados gerados com sucesso!"); 
                })
                .catch(error => {
                    console.error(error);
                    alert("Erro ao gerar dados aleatórios.");
                })
                .finally(() => {
                    this.gerando_aleatorios = false;
                });
        },

        ExecutarDistribuicao() {

            // 1. VALIDAÇÕES PRÉVIAS
            // Verifica se há um processo modelo salvo
            if (!this.processo || !this.processo.id) {
                alert("Erro: O processo modelo não foi salvo corretamente. Revise o Passo 1.");
                return;
            }

            // Valida Assuntos
            if (!this.processo.assuntos || this.processo.assuntos.length === 0) {
                alert("Erro de Validação:\nO processo modelo precisa ter pelo menos um ASSUNTO cadastrado.\nVerifique o Passo 2.");
                return;
            }

            // Valida Polo Ativo (Autores Fictícios)
            if (!this.processo.polo_ativo || this.processo.polo_ativo.length === 0) {
                alert("Erro de Validação:\nO processo modelo precisa ter pelo menos uma PARTE AUTORA (Polo Ativo).\nVerifique o Passo 3.");
                return;
            }

            // Valida Polo Passivo (Réus Fictícios)
            if (!this.processo.polo_passivo || this.processo.polo_passivo.length === 0) {
                alert("Erro de Validação:\nO processo modelo precisa ter pelo menos uma PARTE RÉ (Polo Passivo).\nVerifique o Passo 3.");
                return;
            }

            // Valida Petições (Documentos)
            // Verifica se existe o array peticoes E se ele tem itens
            if (!this.processo.peticoes || this.processo.peticoes.length === 0) {
                alert("Erro de Validação:\nO processo modelo precisa ter pelo menos uma petição gerado.\nVerifique o Passo 4.");
                return;
            }

            // Verifica se há alunos selecionados conforme o modo
            let totalAlunos = 0;
            if (this.modo_distribuicao === 'individual_este_modo_foi_desativado') {
                totalAlunos = this.alunos_selecionados_individual.length;
                if (totalAlunos === 0) {
                    alert("Selecione pelo menos um aluno para a distribuição individual.");
                    return;
                }
            } else {
                // No modo compartilhado, geralmente precisa de gente nos dois polos, 
                // mas deixarei flexível (pelo menos 1 no total)
                totalAlunos = this.alunos_polo_ativo.length + this.alunos_polo_passivo.length;
                if (totalAlunos === 0) {
                    alert("Adicione alunos aos polos Ativo ou Passivo para continuar.");
                    return;
                }
            }

            // 2. CONFIRMAÇÃO DO USUÁRIO
            let mensagemConfirmacao = "";
            if (this.modo_distribuicao === 'individual') {
                mensagemConfirmacao = `Confirma a geração de ${totalAlunos} NOVOS PROCESSOS (cópias)?\nIsso pode levar alguns instantes.`;
            } else {
                mensagemConfirmacao = `Confirma o vínculo de ${totalAlunos} alunos neste processo único?`;
            }

            if (!confirm(mensagemConfirmacao)) return;

            // 3. PREPARAÇÃO DO PAYLOAD
            this.processando_distribuicao = true;

            // Extraímos apenas os IDs dos objetos de alunos para o backend (Payload mais leve)
            const payload = {
                // Identificação do Modelo
                processo_modelo_id: this.processo.id,
                
                // Dados do Processo (caso o backend precise atualizar algo antes de copiar)
                processo_dados: this.processo, 

                // Configuração da Distribuição
                modo: this.modo_distribuicao, // 'individual' ou 'compartilhado' - Isso impacta na forma que vai gerar no backend então manda do jeito atual mesmo.
                
                // Listas de IDs (Mapeamos o array de objetos para array de inteiros)
                ids_individual: this.alunos_selecionados_individual.map(a => a.id),
                ids_polo_ativo: this.alunos_polo_ativo.map(a => a.id),
                ids_polo_passivo: this.alunos_polo_passivo.map(a => a.id)
            };

            console.log("Enviando Payload:", payload); // Para debug

            // 4. ENVIO PARA O BACKEND
            axios.post(this.BASE_URL + 'processos/distribuir_lote', payload)
            .then(response => {
                const dados = response.data.dados_retorno;
                
                if (this.modo_distribuicao === 'individual') {
                    // Exemplo: Monta uma string com os nomes e códigos
                    let msg = `${dados.titulo}\nForam gerados ${dados.total_gerado} processos:\n\n`;
                    dados.lista_detalhada.forEach(item => {
                        msg += `• ${item.aluno} -> Processo: ${item.codigo_processo}\n`;
                    });
                    alert(msg);
                } 
                else {
                    // Modo Compartilhado
                    alert(`${dados.titulo}\n\nProcesso: ${dados.codigo_processo}\n\n${dados.msg_ativo}\n${dados.msg_passivo}`);
                }

                // Redireciona
                window.location.href = this.BASE_URL + 'distribuicao_lote'; 
            })
                .catch(error => {
                    console.error("Erro na distribuição:", error);
                    let msg = "Ocorreu um erro ao processar a distribuição.";
                    if (error.response && error.response.data && error.response.data.message) {
                        msg += "\nDetalhe: " + error.response.data.message;
                    }
                    alert(msg);
                })
                .finally(() => {
                    this.processando_distribuicao = false;
                });
        },

        // Função utilitária para comparar dois arrays de objetos baseando-se no ID
        ArraysSaoIguais(arrayTela, arrayOriginal) {
            // 1. Se os tamanhos forem diferentes, já sabemos que mudou
            if (arrayTela.length !== arrayOriginal.length) return false;

            // 2. Extrai os IDs e ordena para garantir que a ordem não afete a comparação
            const idsTela = arrayTela.map(a => a.id).sort();
            const idsOriginal = arrayOriginal.map(a => a.id).sort();

            // 3. Compara ID por ID
            return JSON.stringify(idsTela) === JSON.stringify(idsOriginal);
        },

        VerificarSeHaAlteracoes() {
            const origAtivo = this.processo.advogados_colaboradores || [];
            const origPassivo = this.processo.advogados_reus || [];

            if (this.modo_distribuicao === 'individual') {
                // No modo individual, a "origem" é a união de ativos + passivos sem duplicatas
                // Recriamos essa lógica aqui para ter a base de comparação
                const todosOriginais = [...origAtivo, ...origPassivo];
                const mapIds = new Map();
                const origIndividual = [];
                
                for (const aluno of todosOriginais) {
                    if (!mapIds.has(aluno.id)) {
                        mapIds.set(aluno.id, true);
                        origIndividual.push(aluno);
                    }
                }

                // Compara o que está na tela com essa lista unificada original
                return !this.ArraysSaoIguais(this.alunos_selecionados_individual, origIndividual);
            } 
            else {
                // No modo compartilhado, compara cada polo separadamente
                const mudouAtivo = !this.ArraysSaoIguais(this.alunos_polo_ativo, origAtivo);
                const mudouPassivo = !this.ArraysSaoIguais(this.alunos_polo_passivo, origPassivo);
                
                return mudouAtivo || mudouPassivo;
            }
        },

        AlteradoModoDistribuicao(novoModo) {
            // 1. Se clicou no que já está selecionado, não faz nada
            if (this.modo_distribuicao === novoModo) return;

            // 2. CORREÇÃO: Validação só roda se NÃO for a primeira seleção (modo vazio)
            /*if (this.modo_distribuicao !== '') {
                if (this.VerificarSeHaAlteracoes()) {
                    const confirmacao = confirm("Atenção: Você fez alterações na lista de alunos desta aba que ainda não foram salvas.\n\nSe você trocar o modo de distribuição agora, essas alterações serão PERDIDAS e a lista será redefinida para o original.\n\nDeseja continuar mesmo assim?");
                    
                    if (!confirmacao) {
                        return; // O return agora funciona porque o v-model não alterou a variável antes!
                    }
                }
            } */

            // 3. Aplica a mudança e carrega as listas
            this.modo_distribuicao = novoModo;

            // 1. Garantimos que sempre teremos arrays (se for nulo, vira [])
            const arrayAtivosProcesso = this.processo.advogados_colaboradores || [];
            const arrayAtivosLocal = this.alunos_polo_ativo || [];

            const arrayPassivosProcesso = this.processo.advogados_reus || [];
            const arrayPassivosLocal = this.alunos_polo_passivo || [];

            // 2. Juntamos os arrays (Processo + Local)
            const todosAtivos = [...arrayAtivosProcesso, ...arrayAtivosLocal];
            const todosPassivos = [...arrayPassivosProcesso, ...arrayPassivosLocal];

            // 3. Removemos as duplicatas baseadas no 'id' do objeto usando Map
            // O Map automaticamente substitui chaves iguais, deixando apenas um registro por ID
            const advogadosAtivos = Array.from(new Map(todosAtivos.map(item => [item.id, item])).values());
            const advogadosPassivos = Array.from(new Map(todosPassivos.map(item => [item.id, item])).values());

            // 4. Atribui às variáveis se o modo estiver correto
            if (novoModo === 'compartilhado' || novoModo === 'individual') {
                this.alunos_polo_ativo = [...advogadosAtivos];
                this.alunos_polo_passivo = [...advogadosPassivos];
            }
            //Nem vai cair mais neste else if, mas mantive aqui por enquanto.
            else if (novoModo === 'individual') {
                const todosAlunos = [...advogadosAtivos, ...advogadosPassivos];
                const listaUnica = [];
                const mapIds = new Map();

                for (const aluno of todosAlunos) {
                    if (!mapIds.has(aluno.id)) {
                        mapIds.set(aluno.id, true); 
                        listaUnica.push(aluno);
                    }
                }
                this.alunos_selecionados_individual = listaUnica;
            }
        },


        GravarProcessoInicial() {
            if(!this.cidade_selecionada || !this.rito_selecionado || !this.area_selecionada || !this.classe_processual_selecionada || !this.valor_causa) {
                alert("Por favor, preencha todos os campos obrigatórios para iniciar o modelo.");
                return;
            }

            this.carregando = true;

            const dados_gravar = {
                cidade_selecionada: this.cidade_selecionada,
                rito_selecionado: this.rito_selecionado,
                area_selecionada: this.area_selecionada,
                classe_processual_selecionada: this.classe_processual_selecionada.id,
                nivel_sigilo_selecionado: this.nivel_sigilo_selecionado,
                processo_originario: this.processo_originario,
                valor_causa: this.valor_causa,
                valor_causa_nao_se_aplica: this.valor_causa_nao_se_aplica,
                previsao_custas: this.previsao_custas,
                valor_alcada: this.valor_alcada,
                juizo: this.juizo,
                login_outros_usuarios: this.login_outros_usuarios,
                processo: this.processo, 
            };

            axios.post(this.BASE_URL + 'cadastrar/processo', dados_gravar)
                .then(response => {
                    if (response.status === 200) {
                        this.processo = response.data;
                        this.$store.commit('setProcesso', this.processo); 
                    }
                })
                .catch(error => {
                    alert('Erro ao gravar dados iniciais: ' + error);
                })
                .finally(() => {
                    this.carregando = false;
                });
        },

        // --- MÉTODOS DE DISTRIBUIÇÃO ---
        
        buscarAlunos() {
            if(this.termo_busca_aluno.length < 3) return;

            axios.get(this.BASE_URL + 'buscar/usuarios', { params: { termo: this.termo_busca_aluno } })
                .then(response => {
                    this.alunos_encontrados = response.data;
                })
                .catch(error => {
                    console.error("Erro ao buscar alunos", error);
                    // Mock para teste visual
                    this.alunos_encontrados = [
                        { id: 101, name: 'João da Silva (RA 12345)', email: 'joao@unip.br' },
                        { id: 102, name: 'Maria Oliveira (RA 67890)', email: 'maria@unip.br' },
                        { id: 103, name: 'Turma Direito Manhã', email: 'Grupo' },
                    ];
                });
        },

        adicionarAluno(aluno, destino) {
            // Função genérica para adicionar nas listas corretas
            const existe = (lista) => lista.find(a => a.id === aluno.id);

            if (destino === 'individual') {
                if (!existe(this.alunos_selecionados_individual)) {
                    this.alunos_selecionados_individual.push(aluno);
                }
            } else if (destino === 'ativo') {
                if (!existe(this.alunos_polo_ativo)) {
                    // Remove do passivo se estiver lá (para não estar nos dois polos)
                    this.alunos_polo_passivo = this.alunos_polo_passivo.filter(a => a.id !== aluno.id);
                    this.alunos_polo_ativo.push(aluno);
                }
            } else if (destino === 'passivo') {
                if (!existe(this.alunos_polo_passivo)) {
                    // Remove do ativo se estiver lá
                    this.alunos_polo_ativo = this.alunos_polo_ativo.filter(a => a.id !== aluno.id);
                    this.alunos_polo_passivo.push(aluno);
                }
            }
            
            this.termo_busca_aluno = '';
            this.alunos_encontrados = [];
        },

        removerAluno(index, origem) {
            if (origem === 'individual') this.alunos_selecionados_individual.splice(index, 1);
            if (origem === 'ativo') this.alunos_polo_ativo.splice(index, 1);
            if (origem === 'passivo') this.alunos_polo_passivo.splice(index, 1);
        },

        gerarAlunosTeste() {
            if (this.modo_distribuicao === 'individual') {
                this.alunos_selecionados_individual.push(
                    { id: Math.random(), name: 'Aluno Teste Individual', email: 'teste@unip.br' }
                );
            } else {
                this.alunos_polo_ativo.push({ id: Math.random(), name: 'Advogado Autor 1', email: 'autor@unip.br' });
                this.alunos_polo_passivo.push({ id: Math.random(), name: 'Advogado Réu 1', email: 'reu@unip.br' });
            }
        },

        // 1. BUSCA DE ALUNOS (Baseada no seu snippet)
        buscaAlunos() {
            if (this.termo_busca_aluno.length < 3) {
                this.alunos_encontrados = [];
                return;
            }

            axios.get(this.BASE_URL + "usuarios/buscar", { params: { query: this.termo_busca_aluno } })
                .then(response => {
                    this.alunos_encontrados = response.data;
                })
                .catch(error => {
                    console.error('Erro ao buscar alunos:', error);
                    this.alunos_encontrados = [];
                });
        },

        // 2. BUSCA DE GRUPOS (Baseada no seu snippet)
        buscaGrupos() {
            if (this.termo_busca_grupo.length < 3) {
                this.grupos_encontrados = [];
                return;
            }

            axios.get(this.BASE_URL + "buscar_grupos", { params: { filtro: this.termo_busca_grupo } })
                .then(response => {
                    this.grupos_encontrados = response.data;
                })
                .catch(error => {
                    console.error('Erro ao buscar grupos:', error);
                    this.grupos_encontrados = [];
                });
        },

        // 3. FUNÇÃO CENTRAL DE ADIÇÃO (Gerencia Destino e Expansão de Grupo)
        adicionarItem(item, tipo_origem) {
            
            // Define qual é o array de destino baseado no Modo e na Seleção do Radio
            let destino = '';

            if (this.modo_distribuicao === 'individual_desativo') {
                destino = 'individual';
            } else {
                // Se for colaborativo, obedece o radio button
                destino = this.destino_colaborativo_selecionado; 
            }

            // Lógica de Adição
            if (tipo_origem === 'aluno') {
                // Adiciona um único aluno
                this.processarAdicaoAluno(item, destino);
                this.termo_busca_aluno = '';
                this.alunos_encontrados = [];
            } 
            else if (tipo_origem === 'grupo') {
                // Adiciona TODOS os membros do grupo
                if (item.users && item.users.length > 0) {
                    let count = 0;
                    item.users.forEach(aluno => {
                        const adicionou = this.processarAdicaoAluno(aluno, destino);
                        if(adicionou) count++;
                    });
                    // Feedback visual opcional (toastr ou alert)
                    // alert(`${count} alunos do grupo foram adicionados.`);
                }
                this.termo_busca_grupo = '';
                this.grupos_encontrados = [];
            }
        },

        // Função auxiliar que faz a inserção e validação de duplicidade
        processarAdicaoAluno(aluno, destino) {
            // Verifica duplicidade genérica na lista alvo
            const existe = (lista) => lista.find(a => a.id === aluno.id);

            
            if (destino === 'individual') {
                if (!existe(this.alunos_selecionados_individual)) {
                    this.alunos_selecionados_individual.push(aluno);
                    return true;
                }
            } 
            else if (destino === 'ativo') {
                if (!existe(this.alunos_polo_ativo)) {
                    // Remove do passivo se já estiver lá (regra de exclusividade)
                    this.alunos_polo_passivo = this.alunos_polo_passivo.filter(a => a.id !== aluno.id);
                    this.alunos_polo_ativo.push(aluno);
                    return true;
                }
            } 
            else if (destino === 'passivo') {
                if (!existe(this.alunos_polo_passivo)) {
                    // Remove do ativo se já estiver lá
                    this.alunos_polo_ativo = this.alunos_polo_ativo.filter(a => a.id !== aluno.id);
                    this.alunos_polo_passivo.push(aluno);
                    return true;
                }
            }
            return false;
        },

        formatarValorMonetario() {
            let valor = this.valor_causa.replace(/\D/g, '');
            valor = (valor / 100).toFixed(2) + '';
            valor = valor.replace(".", ",");
            valor = valor.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            this.valor_causa = valor;
            this.calculaPrevisaoCustas();
        },
        calculaPrevisaoCustas(){
            let valor = this.valor_causa.replace(/\D/g, ''); // Remove tudo o que não é dígito
            valor = (valor / 100).toFixed(2) + ''; // Converte para decimal
            
            if (isNaN(valor)) {
                return 0; // Retorna 0 ou oculta a mensagem se não for um número ou for menor ou igual a zero
            }

            let calculo = valor * 0.025; // Calcula 2.5% do valor da causa

            if(valor <= 0){
                calculo = 0;
            }
            else if(calculo < 253.90){
                calculo = 253.90;
            }

            //calculo = calculo.toString().replace(".", ",");
            //calculo = calculo.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

            //this.previsao_custas = calculo;
            this.previsao_custas = new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                }).format(calculo);
        },
        CarregarDados(dados_carregar){
            axios.get(this.BASE_URL + 'buscar/dados_iniciais/' + dados_carregar)
                .then(response => {
                    if(dados_carregar == 'cidades') this.cidades = response.data;
                    else if(dados_carregar == 'ritos') this.ritos = response.data;
                    else if(dados_carregar == 'areas') this.areas = response.data;
                    else if(dados_carregar == 'classes') this.classes_processuais = response.data;
                })
                .catch(error => { console.error('Erro ao buscar '+dados_carregar, error); });
        },
        CarregarCidades(){ this.CarregarDados('cidades'); },
        CarregarRitos(){ this.CarregarDados('ritos'); },
        CarregarAreas(){ this.CarregarDados('areas'); },
        CarregarClasses(){ this.CarregarDados('classes'); },
    },
    mounted() {
        this.CarregarCidades();
        this.CarregarRitos();
        this.CarregarAreas();
        this.CarregarClasses();
    },
};
</script>

<style scoped>

h1{
    font-size: 26px;
}

.form-container {
    border: 1px solid #dee2e6;
    padding: 20px;
    position: relative;
    margin-top: 15px;
    border-radius: 8px;
    background-color: #ffffff;
}

.form-title {
    position: absolute;
    top: -12px;
    left: 15px;
    background: #fff;
    padding: 0 10px;
    font-weight: bold;
    font-size: 0.9rem;
}

.card-option {
    transition: all 0.3s ease;
    background-color: #f8f9fa;
}

.card-option:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
}

.selected-mode {
    background-color: #e8f5e9;
    border-color: #28a745 !important;
    border-width: 2px !important;
    color: #155724;
}

.cursor-pointer {
    cursor: pointer;
}

/* Scroll e ajustes de lista */
.list-group-item {
    font-size: 0.9rem;
}

.btn-xs {
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
}
</style>